"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.success.completed': 'Onboarding completed successfully! Your AI assistant is ready.',
    'onboarding.success.progress_saved': 'Progress saved successfully',
};
